import React, { memo, useEffect } from "react";

import AddExternalEmailUsersInfoModal from "modules/modals/add-external-email-users-info-modal";
import ConfirmRemoveUsersGroupsModal from "modules/modals/confirm-remove-users-groups-modal";
import ConfirmUnlockConversationModal from "modules/modals/confirm-unlock-conversation-modal";
import DeleteFileModal from "modules/modals/delete-file-modal";
import DeleteJobsModal from "modules/modals/delete-jobs-modal";
import DeleteMessageModal from "modules/modals/delete-message-modal";
import DisableSmsModal from "modules/modals/disable-sms-modal";
import DownloadAllFilesModal from "modules/modals/download-all-files-modal";
import EditMessageModal from "modules/modals/edit-message-modal";
import EditUserAvatarModal from "modules/modals/edit-user-avatar-modal";
import EditUserLocaleModal from "modules/modals/edit-user-locale-modal";
import EmailInfoModal from "modules/modals/email-info-modal";
import ExportConversationModal from "modules/modals/export-conversation-modal";
import LockConversationGeneralInfoModal from "modules/modals/lock-conversation-general-info-modal";
import LockedConversationModal from "modules/modals/locked-conversation-modal";
import MessageThreadCreateReminderModal from "modules/modals/message-thread-create-reminder-modal";
import MessageThreadEditSubjectModal from "modules/modals/message-thread-edit-subject-modal";
import MessageThreadFileGalleryModal from "modules/modals/message-thread-file-gallery-modal";
import PinnedMessageThreadsLimitModal from "modules/modals/pinned-message-threads-limit-modal";
import PrintConversationModal from "modules/modals/print-conversation-modal";
import UnlockedConversationModal from "modules/modals/unlocked-conversation-modal";
import AdminConfirmArchiveDistriubtionGroupModal from "modules/admin/admin-confirm-archive-distribution-group-modal";
import AdminConfirmArchiveTagModal from "modules/admin/admin-confirm-archive-tag-modal";
import AdminConfirmUnarchiveDistriubtionGroupModal from "modules/admin/admin-confirm-unarchive-distribution-group-modal";
import AdminConfirmUnarchiveTagModal from "modules/admin/admin-confirm-unarchive-tag-modal";
import AdminDeactivateMultipleUsersModal from "modules/admin/admin-deactivate-multiple-users-modal";
import AdminDeactivateUserModal from "modules/admin/admin-deactivate-user-modal";
import AdminReactivateUserModal from "modules/admin/admin-reactivate-user-modal";
import AdminTagCategoryModal from "modules/admin/admin-tag-category-modal";
import InternalAdminConfirmArchiveTagModal from "modules/internal-admin/modals/internal-admin-confirm-archive-tag-modal";
import InternalAdminConfirmUnarchiveTagModal from "modules/internal-admin/modals/internal-admin-confirm-unarchive-tag-modal";
import InternalAdminDeactivateMultipleUsersModal from "modules/internal-admin/modals/internal-admin-deactivate-multiple-users-modal";
import InternalAdminDeactivateUserModal from "modules/internal-admin/modals/internal-admin-deactivate-user-modal";
import InternalAdminOrganizationModal from "modules/internal-admin/modals/internal-admin-organization-modal";
import InternalAdminReactivateUserModal from "modules/internal-admin/modals/internal-admin-reactivate-user-modal";
import InternalAdminTagCategoryModal from "modules/internal-admin/modals/internal-admin-tag-category-modal";
import CallOptionsModal from "../../modals/call-options-modal";
import IncomingCallModal from "../../modals/incoming-call-modal";
import AddPendingEmailUsersModal from "modules/modals/add-pending-email-users-modal";
import EditImageModal from "modules/modals/edit-image-modal";
import { MODAL_TYPE, useOverlay } from "./overlay-provider";
import FileInTransitModal from "modules/modals/file-in-transit-modal";
import OutOfOfficeModal from "modules/modals/out-of-office-modal";
import InviteModal from "modules/modals/invite-modal";
import ReadOnlyThreadsInfoModal from "modules/modals/read-only-threads-info-modal";
import ConfirmReadOnlyThreadModal from "modules/modals/confirm-read-only-thread-modal";
import ConfirmRemoveReadOnlyThreadModal from "modules/modals/confirm-remove-read-only-thread-modal";
import AdminDistributionGroupQueryModal from "modules/admin/admin-distribution-group-query-modal";
import AdminDistributionGroupPreviewUsersModal from "modules/admin/admin-distribution-group-preview-users-modal";
import AdminDistributionGroupAddedModal from "modules/admin/admin-distribution-group-added-modal";
import AdminAddUserAttributeCategoryModal from "modules/admin/admin-add-user-attribute-category-modal";
import AdminEditUserAttributesModal from "modules/admin/admin-edit-user-attributes-modal";
import HelpModal from "modules/modals/help-modal";
import AdminCreateTagModal from "modules/admin/admin-create-tag-modal";
import ConfirmModal from "modules/modals/confirm-modal";
import AdminCreateUserAttributeModal from "modules/admin/admin-create-user-attribute-modal";
import AdminEditTagModal from "modules/admin/admin-edit-tag-modal";
import InternalAdminDistributionGroupQueryModal from "modules/internal-admin/modals/internal-admin-distribution-group-query-modal";
import InternalAdminDistributionGroupPreviewUsersModal from "modules/internal-admin/modals/internal-admin-distribution-group-preview-users-modal";
import InternalAdminEditUserAttributesModal from "modules/internal-admin/modals/internal-admin-edit-user-attributes-modal";
import InternalAdminAddUserAttributeCategoryModal from "modules/internal-admin/modals/internal-admin-add-user-attribute-category-modal";
import InternalAdminCreateTagModal from "modules/internal-admin/modals/internal-admin-create-tag-modal";
import InternalAdminEditTagModal from "modules/internal-admin/modals/internal-admin-edit-tag-modal";
import InternalAdminCreateUserAttributeModal from "modules/internal-admin/modals/internal-admin-create-user-attribute-modal";
import AdminAddUsersToDistributionGroups from "modules/admin/admin-add-users-to-distribution-groups-modal";
import InternalAdminAddUsersToDistributionGroupsModal from "modules/internal-admin/modals/internal-admin-add-users-to-distribution-groups-modal";

const Modals = () => {
  const { modalState, closeModal } = useOverlay();
  const [component, setComponent] = React.useState<React.ReactNode>();

  useEffect(() => {
    if (!modalState) {
      setComponent(undefined);
      return;
    }
    switch (modalState.type) {
      case MODAL_TYPE.HELP:
        if (!modalState.helpModal) break;
        setComponent(<HelpModal helpModal={modalState.helpModal} />);
        break;
      case MODAL_TYPE.CONFIRM:
        if (!modalState.helpModal || !modalState.onSaveCallback) break;
        setComponent(
          <ConfirmModal
            helpModal={modalState.helpModal}
            onSaveCallback={modalState.onSaveCallback}
          />,
        );
        break;
      case MODAL_TYPE.MESSAGE_THREAD_FILE_GALLERY:
        if (!modalState.id) break;
        setComponent(
          <MessageThreadFileGalleryModal
            messageThreadId={modalState.id}
            fileId={modalState.id2}
          />,
        );
        break;
      case MODAL_TYPE.EDIT_SUBJECT:
        if (!modalState.id) return;
        setComponent(
          <MessageThreadEditSubjectModal messageThreadId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.CREATE_REMINDER:
        if (!modalState.id) return;
        setComponent(
          <MessageThreadCreateReminderModal messageThreadId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.EDIT_USER_LOCALE:
        setComponent(<EditUserLocaleModal messageThreadId={modalState.id} />);
        break;
      case MODAL_TYPE.DELETE_MESSAGE:
        if (!modalState.id) return;
        setComponent(<DeleteMessageModal messageId={modalState.id} />);
        break;
      case MODAL_TYPE.DELETE_FILE:
        if (!modalState.id || !modalState.id2) return;
        setComponent(
          <DeleteFileModal
            fileId={modalState.id}
            messageThreadId={modalState.id2}
          />,
        );
        break;
      case MODAL_TYPE.EDIT_USER_AVATAR:
        setComponent(<EditUserAvatarModal />);
        break;
      case MODAL_TYPE.EDIT_IMAGE:
        if (!modalState.fileInTransit) return;
        setComponent(
          <EditImageModal fileInTransit={modalState.fileInTransit} />,
        );
        break;
      case MODAL_TYPE.EDIT_MESSAGE:
        if (!modalState.id) return;
        setComponent(<EditMessageModal messageId={modalState.id} />);
        break;
      case MODAL_TYPE.EMAIL_INFO:
        setComponent(<EmailInfoModal />);
        break;
      case MODAL_TYPE.MAKE_PRIVATE_GENERAL_INFO:
        setComponent(<LockConversationGeneralInfoModal />);
        break;
      case MODAL_TYPE.CONFIRM_UNLOCK_CONVERSATION:
        if (!modalState.id) return;
        setComponent(
          <ConfirmUnlockConversationModal messageThreadId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.CONFIRM_REMOVE_USERS_GROUPS:
        if (!modalState.id || !modalState.ids) return;
        setComponent(
          <ConfirmRemoveUsersGroupsModal
            messageThreadId={modalState.id}
            userAndDistributionGroupIds={modalState.ids}
          />,
        );
        break;
      case MODAL_TYPE.LOCKED_CONVERSATION:
        if (!modalState.id) return;
        setComponent(<LockedConversationModal lockedUserId={modalState.id} />);
        break;
      case MODAL_TYPE.UNLOCKED_CONVERSATION:
        setComponent(<UnlockedConversationModal />);
        break;
      case MODAL_TYPE.ADD_EXTERNAL_EMAIL_USERS:
        setComponent(<AddExternalEmailUsersInfoModal />);
        break;
      case MODAL_TYPE.PRINT_CONVERSATION:
        if (!modalState.id) return;
        setComponent(<PrintConversationModal jobId={modalState.id} />);
        break;
      case MODAL_TYPE.EXPORT_CONVERSATION:
        if (!modalState.id) return;
        setComponent(
          <ExportConversationModal messageThreadId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.DOWNLOAD_ALL_FILES:
        if (!modalState.id) return;
        setComponent(<DownloadAllFilesModal messageThreadId={modalState.id} />);
        break;
      case MODAL_TYPE.DELETE_ALL_JOBS:
        setComponent(<DeleteJobsModal />);
        break;
      case MODAL_TYPE.PINNED_MESSAGE_THREADS_LIMIT:
        setComponent(<PinnedMessageThreadsLimitModal />);
        break;
      case MODAL_TYPE.CALL_OPTIONS: {
        if (!modalState.ids) return;
        setComponent(<CallOptionsModal userIds={modalState.ids} />);
        break;
      }
      case MODAL_TYPE.INCOMING_CALL: {
        if (!modalState.call) return;
        setComponent(<IncomingCallModal call={modalState.call} />);
        break;
      }
      case MODAL_TYPE.DISABLE_SMS: {
        setComponent(<DisableSmsModal />);
        break;
      }
      case MODAL_TYPE.ADD_PENDING_EMAIL_USERS: {
        if (!modalState.id || !modalState.ids) return;
        setComponent(
          <AddPendingEmailUsersModal
            messageThreadId={modalState.id}
            pendingEmailUserIdList={modalState.ids}
          />,
        );
        break;
      }
      case MODAL_TYPE.FILE_IN_TRANSIT: {
        if (!modalState.fileInTransit) return;
        setComponent(<FileInTransitModal file={modalState.fileInTransit} />);
        break;
      }
      case MODAL_TYPE.OUT_OF_OFFICE: {
        setComponent(<OutOfOfficeModal />);
        break;
      }
      case MODAL_TYPE.INVITE: {
        setComponent(<InviteModal />);
        break;
      }
      case MODAL_TYPE.READ_ONLY_INFO: {
        setComponent(<ReadOnlyThreadsInfoModal />);
        break;
      }
      case MODAL_TYPE.CONFIRM_READ_ONLY_THREAD: {
        if (!modalState.id) return;
        setComponent(
          <ConfirmReadOnlyThreadModal messageThreadId={modalState.id} />,
        );
        break;
      }
      case MODAL_TYPE.CONFIRM_REMOVE_READ_ONLY_THREAD: {
        if (!modalState.id) return;
        setComponent(
          <ConfirmRemoveReadOnlyThreadModal messageThreadId={modalState.id} />,
        );
        break;
      }
      case MODAL_TYPE.ADMIN_DISTRIBUTION_GROUP_ADDED:
        setComponent(
          <AdminDistributionGroupAddedModal
            distributionGroupId={modalState.id}
          />,
        );
        break;
      case MODAL_TYPE.ADMIN_CREATE_TAG:
        setComponent(
          <AdminCreateTagModal onSaveCallback={modalState.onSaveCallback} />,
        );
        break;
      case MODAL_TYPE.ADMIN_EDIT_TAG:
        if (!modalState.id) return;
        setComponent(<AdminEditTagModal tagId={modalState.id} />);
        break;
      case MODAL_TYPE.ADMIN_CREATE_USER_ATTRIBUTE_TAG:
        if (!modalState.id) return;
        setComponent(
          <AdminCreateUserAttributeModal
            userAttributeCategoryId={modalState.id}
          />,
        );
        break;
      case MODAL_TYPE.ADMIN_DEACTIVATE_USER:
        if (!modalState.id) return;
        setComponent(<AdminDeactivateUserModal userId={modalState.id} />);
        break;
      case MODAL_TYPE.ADMIN_DEACTIVATE_MULTIPLE_USERS:
        if (!modalState.ids) return;
        setComponent(
          <AdminDeactivateMultipleUsersModal userIds={modalState.ids} />,
        );
        break;
      case MODAL_TYPE.ADMIN_REACTIVATE_USER:
        if (!modalState.id) return;
        setComponent(<AdminReactivateUserModal userId={modalState.id} />);
        break;
      case MODAL_TYPE.ADMIN_TAG_CATEGORY:
        setComponent(<AdminTagCategoryModal tagCategoryId={modalState.id} />);
        break;
      case MODAL_TYPE.ADMIN_CONFIRM_ARCHIVE_DISTRIBUTION_GROUP:
        if (!modalState.ids) return;
        setComponent(
          <AdminConfirmArchiveDistriubtionGroupModal
            distributionGroupIds={modalState.ids}
          />,
        );
        break;
      case MODAL_TYPE.ADMIN_CONFIRM_UNARCHIVE_DISTRIBUTION_GROUP:
        if (!modalState.ids) return;
        setComponent(
          <AdminConfirmUnarchiveDistriubtionGroupModal
            distributionGroupIds={modalState.ids}
          />,
        );
        break;
      case MODAL_TYPE.ADMIN_CONFIRM_ARCHIVE_TAG:
        if (!modalState.ids) return;
        setComponent(<AdminConfirmArchiveTagModal tagIds={modalState.ids} />);
        break;
      case MODAL_TYPE.ADMIN_CONFIRM_UNARCHIVE_TAG:
        if (!modalState.ids) return;
        setComponent(<AdminConfirmUnarchiveTagModal tagIds={modalState.ids} />);
        break;
      case MODAL_TYPE.ADMIN_ADD_USER_ATTRIBUTE_CATEGORY:
        setComponent(<AdminAddUserAttributeCategoryModal />);
        break;
      case MODAL_TYPE.ADMIN_DISTRIBUTION_GROUP_QUERY:
        if (!modalState.onSaveCallback) return;
        setComponent(
          <AdminDistributionGroupQueryModal
            onSave={modalState.onSaveCallback}
            query={modalState.query}
          />,
        );
        break;
      case MODAL_TYPE.ADMIN_DISTRIBUTION_GROUP_PREVIEW_USERS:
        if (!modalState.adminPreviewDistributionGroupMembershipInput) return;
        setComponent(
          <AdminDistributionGroupPreviewUsersModal
            adminPreviewDistributionGroupMembershipInput={
              modalState.adminPreviewDistributionGroupMembershipInput
            }
            query={modalState.query}
          />,
        );
        break;
      case MODAL_TYPE.ADMIN_EDIT_USER_ATTRIBUTES:
        if (!modalState.id) return;
        setComponent(<AdminEditUserAttributesModal userId={modalState.id} />);
        break;
      case MODAL_TYPE.ADMIN_ADD_USERS_TO_DISTRIBUTION_GROUPS:
        if (!modalState.ids) return;
        setComponent(
          <AdminAddUsersToDistributionGroups userIds={modalState.ids} />,
        );
        break;

      case MODAL_TYPE.INTERNAL_ADMIN_ADD_ORGANIZATION:
        setComponent(
          <InternalAdminOrganizationModal organizationId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_DEACTIVATE_USER:
        if (!modalState.id) return;
        setComponent(
          <InternalAdminDeactivateUserModal userId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_REACTIVATE_USER:
        if (!modalState.id) return;
        setComponent(
          <InternalAdminReactivateUserModal userId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_CREATE_TAG:
        setComponent(
          <InternalAdminCreateTagModal
            onSaveCallback={modalState.onSaveCallback}
          />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_EDIT_TAG:
        if (!modalState.id) return;
        setComponent(<InternalAdminEditTagModal tagId={modalState.id} />);
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_TAG_CATEGORY:
        setComponent(
          <InternalAdminTagCategoryModal tagCategoryId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_DEACTIVATE_MULTIPLE_USERS:
        if (!modalState.ids) return;
        setComponent(
          <InternalAdminDeactivateMultipleUsersModal
            userIds={modalState.ids}
          />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_CONFIRM_ARCHIVE_TAG:
        if (!modalState.ids) return;
        setComponent(
          <InternalAdminConfirmArchiveTagModal tagIds={modalState.ids} />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_CONFIRM_UNARCHIVE_TAG:
        if (!modalState.ids) return;
        setComponent(
          <InternalAdminConfirmUnarchiveTagModal tagIds={modalState.ids} />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_DISTRIBUTION_GROUP_QUERY:
        if (!modalState.onSaveCallback) return;
        setComponent(
          <InternalAdminDistributionGroupQueryModal
            query={modalState.query}
            onSave={modalState.onSaveCallback}
          />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_DISTRIBUTION_GROUP_PREVIEW_USERS:
        if (!modalState.adminPreviewDistributionGroupMembershipInput) return;
        setComponent(
          <InternalAdminDistributionGroupPreviewUsersModal
            adminPreviewDistributionGroupMembershipInput={
              modalState.adminPreviewDistributionGroupMembershipInput
            }
            query={modalState.query}
          />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_EDIT_USER_ATTRIBUTES:
        if (!modalState.id) return;
        setComponent(
          <InternalAdminEditUserAttributesModal userId={modalState.id} />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_CREATE_USER_ATTRIBUTE:
        if (!modalState.id) return;
        setComponent(
          <InternalAdminCreateUserAttributeModal
            userAttributeCategoryId={modalState.id}
            onSaveCallback={modalState.onSaveCallback}
          />,
        );
        break;
      case MODAL_TYPE.INTERNAL_ADMIN_ADD_USER_ATTRIBUTE_CATEGORY:
        setComponent(
          <InternalAdminAddUserAttributeCategoryModal
            onSaveCallback={modalState.onSaveCallback}
          />,
        );
        break;

      case MODAL_TYPE.INTERNAL_ADMIN_ADD_USERS_TO_DISTRIBUTION_GROUPS:
        if (!modalState.ids) return;
        setComponent(
          <InternalAdminAddUsersToDistributionGroupsModal
            userIds={modalState.ids}
          />,
        );
        break;

      default:
        return undefined;
    }
  }, [closeModal, modalState]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment>{component}</React.Fragment>;
};

export default memo(Modals);
